import { DataGridPro, useGridApiRef } from "@mui/x-data-grid-pro";
import { Button, Form, Input, Modal, Select } from "antd"
import { useContext, useEffect, useState } from "react"
import GeneralContext from "../../context/GeneralContext/GeneralContext";
import api from "../../services/api"
import columns from "../../screens/control/grid_columns/commentary_grid_columns"
import { displayMessage } from "../../services/helper";

export const CommentaryModal = props => {

    const {setShowLoading, mobile_mode, user, setUser} = useContext(GeneralContext)

    const [commentarys, setCommentarys] = useState([])
    useEffect(() => {
        loadCommentarys()
    }, [])

    const gridRef = useGridApiRef()


    const loadCommentarys = async () => {
        try {
            setShowLoading(true)
            let payload = { id: props.currentControl.patient_id, control_id: props.currentControl.control_id }
            let dialy_controls_of_patiente = await api.dialy_controls.list(payload)
            let rs = dialy_controls_of_patiente.data;
            let commentary_list = []
            for (let index = 0; index < rs.length; index++) {
                const element = rs[index];
                if (element?.commentary != null && element?.commentary.length > 0) {
                    commentary_list = commentary_list.concat(element.commentary)
                }
            }
            gridRef.current.setSelectionModel([])
            setCommentarys(commentary_list)
        }
        finally {
            setShowLoading(false)
        }
    }

    const handleCreatoComment = async (values) => {
        try {
            setShowLoading(true)
            await api.dialy_controls.addComment(props.currentControl.id, values)
        } catch (error) {
            let updatedUser = await api.user.get(user?.id)
            setUser(updatedUser.data)
        } finally {
            props.handleOnCloseModal()
            setShowLoading(false)
        }
    }

    return (
        <Modal
            title={<div className="text-xl font-bold text-appian-blue">{displayMessage('COMMENTS')}</div>}
            visible={props.isModalVisible}
            onCancel={props.handleOnCloseModal}
            centered={true}
            footer={[]}
            width={mobile_mode ? '90%' : '60%'}
            height={'80%'}
            style={{ position: 'relative' }}
            bodyStyle={{ height: mobile_mode ? '100vh' : '70vh', display: 'flex', flexDirection: 'column' }}

        >
            <div style={{
                height: '100%',
                display: 'flex',
            }} >
                <DataGridPro
                    rows={commentarys}
                    apiRef={gridRef}
                    style={{ flex: 1, display: 'flex' }}
                    density={"comfortable"}
                    columns={columns(mobile_mode)}
                    pagination
                    pageSize={100}
                    disableMultipleSelection
                    disableSelectionOnClick
                />

            </div>
            <Form
                style={{ display: 'flex', marginTop: 20 }}
                onFinish={handleCreatoComment}
                layout="vertical"
                requiredMark='optional'
            >
                <div style={{ display: 'flex', flex: 1, flexDirection: mobile_mode ? 'column' : 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Form.Item
                        label={mobile_mode ? '' : displayMessage('WRITE_COMMENT')}
                        name="text"
                        className={`w-full flex`}
                        rules={[
                            { required: true, whitespace: true, message: displayMessage('COMMENT_MANDATORY') },
                        ]}
                    >
                        <div>
                            {mobile_mode &&
                                <div>{displayMessage('WRITE_COMMENT')}</div>
                            }
                            <Input.TextArea style={{ height: mobile_mode ? 100 : 80, marginBottom: 5, maxWidth: 500 }} />
                        </div>
                    </Form.Item>
                    <Button
                        type="primary"
                        size='large'
                        htmlType="submit"
                    >
                        {displayMessage('ADD_COMMENT')}
                    </Button>

                </div>
            </Form>

        </Modal>
    )
}